import { isValidPhoneNumber } from 'libphonenumber-js'

let initialized = false;
function initialize(Formsy) {
    if(initialized) {
        // Flex already loaded which means so are the custom validators.
        return;
    }
    customValidators(Formsy);
    initialized = true;
}

function customValidators(Formsy) {
    // If one then both - True if one both fields are present or neither field is present
    Formsy.addValidationRule('ifOneThenBoth', function(values, value, otherField) {
        let _thisField = value,
            _otherField = values[otherField];

        // Assuming a numeric value for _thisField or _otherField, 0 is a falsy value despite indicating in this case
        // a value was added.  Arbitrarily set thespecific field to true if 0 was entered so we don't return a false negative
        if(_thisField === 0) {
            _thisField = true;
        }
        if(_otherField === 0) {
            _otherField = true;
        }
        return (!!_thisField && !!_otherField) || (!_thisField && !_otherField);
    });

    Formsy.addValidationRule('isValidPhoneNumber', function(values, value) {
        return value && isValidPhoneNumber(value, 'US');
    });
}

module.exports = initialize;